<template>
  <div id="container-template-base-div">
    <TypeEdit ref="TypeEdit" v-on:callback="getTypes"></TypeEdit>
    <typeTemplate ref="typeTemplate" v-on:callback="typeTemplateChange"></typeTemplate>
    <Row style="margin-bottom: 8px">
      <Col>
        <Deploy ref="Deploy"></Deploy>
      </Col>
    </Row>
    <Row>
      <Col>
        <Card shadow>
          <div style="float: left">
            <Form :model="searchForm" ref="searchForm" inline :label-width="40" @submit.native.prevent>
              <FormItem label="标题">
                <Input v-model="searchForm.title" @on-enter="getTableData()" style="min-width: 200px" />
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getTableData()">搜索</Button>
                <Button style="margin-left: 8px" @click="searchForm.title = ''">重置</Button>
              </FormItem>
              <FormItem label="分类筛选" :label-width="70">
                <i-switch v-model="typeFilter" @on-change="getTableData">
                  <span slot="open"></span>
                  <span slot="close"></span>
                </i-switch>
              </FormItem>
            </Form>
          </div>
          <div style="text-align: right">
            <Button
              @click="$router.push({name: 'container_template_add'})"
              type="primary"
              icon="md-add">添加模板</Button>
          </div>
        </Card>
      </Col>
    </Row>
    <Row style="margin-bottom: 8px" v-if="typeFilter">
      <Col>
        <Card shadow>
          <Spin fix v-if="typeGetting"></Spin>
          <Alert v-else-if="typeError" type="error" show-icon>
            模板类型数据获取失败
            <a style="float: right" v-on:click="getTypes">刷新</a>
          </Alert>
          <div v-else>
            <div style="float: left">
              <div v-if="typeManagement">
                <span v-for="(item, index) in types" :key="item.id">
                  <Poptip placement="bottom" width="180" transfer>
                    <a>
                      <Icon type="iconfont icon-operate" style="font-family: iconfont;"></Icon>
                      <span style="margin-left: 8px">{{ item.name }}</span>
                    </a>
                    <div slot="content">
                      <!--<Icon type="ios-create" style="color: #ff9900" size="16" />-->
                      <a style="color: #2db7f5" v-on:click="$refs.typeTemplate.showModal(item)">模板管理</a>
                      <Divider type="vertical" />
                      <a style="color: #ff9900" v-on:click="$refs.TypeEdit.showModal(item.id)">编辑</a>
                      <Divider type="vertical" />
                      <a style="color: #ed4014" v-on:click="deleteType(item)">删除</a>
                      <!--<Icon type="md-trash" size="16" style="color: #ed4014" />-->
                    </div>
                  </Poptip>
                  <Divider type="vertical" v-if="index !== types.length - 1" />
                </span>
              </div>
              <CheckboxGroup v-else v-model="selectedTypes" @on-change="typeChange">
                <Checkbox v-for="item in types" :label="item.id" :key="item.id">
                  <span>{{ item.name }}</span>
                  <span style="color: #999">({{ item.templates.length }})</span></Checkbox>
              </CheckboxGroup>
            </div>
            <div style="text-align: right">
              <a v-on:click="typeManagement = !typeManagement">{{ typeManagement ? '退出管理' : '管理' }}</a>
              <Divider type="vertical" />
              <a v-on:click="$refs.TypeEdit.showModal()">添加</a>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="8">
      <Spin fix v-if="listGetting" style="padding-top: 30px"></Spin>
      <Alert show-icon type="error" v-else-if="listError">
        模板数据获取失败
        <a style="float: right" v-on:click="getTableData">刷新</a>
      </Alert>
      <div v-else>
        <Col :lg="12" v-for="item in data" :key="item.id">
          <Card class="container-template">
            <div class="container-template-top">
              <Tag v-for="typeItem in item.type" :key="typeItem.id">{{ typeItem.name }}</Tag>
            </div>
            <div class="container-template-title">
              <span v-on:click="selectTemplate(item.id)">{{ item.title }}</span>
            </div>
            <div class="container-template-summary">
              <div class="container-template-summary-content">
                <article class="context">
                  <span v-if="item.description" v-on:click="selectTemplate(item.id)">{{ item.description }}</span>
                  <div v-else style="height: 21px; display: block"></div>
                </article>
              </div>
            </div>
            <div class="container-template-footer">
              <div class="container-template-footer-operate-btn">
                <Button size="small" type="warning" style="margin-right: 5px" @click="$router.push({name: 'container_template_edit', params: {id: item.id}})">编辑</Button>
                <Poptip
                  confirm
                  transfer
                  title="确定删除此模板吗？"
                  @on-ok="handleDelete(item.id)"
                  ok-text="确认"
                  cancel-text="取消"
                  placement="bottom">
                  <Button size="small" type="error">删除</Button>
                </Poptip>
              </div>
            </div>
          </Card>
        </Col>
      </div>
    </Row>
  </div>
</template>

<script>
import { getContainerTemplates, deleteContainerTemplate, getContainerTemplateTypes,
  deleteContainerTemplateType } from '@/api/container/template'
import typeTemplate from './components/type-template'
import Deploy from './deploy'
import TypeEdit from './components/type-edit'

export default {
  name: 'list',
  components: {
    Deploy,
    TypeEdit,
    typeTemplate
  },
  data () {
    return {
      listGetting: false,
      listError: false,
      searchForm: {
        title: ''
      },
      data: [],
      deployTemplateId: null,
      // 模板类型
      typeFilter: false,
      types: [],
      selectedTypes: [],
      typeError: false,
      typeGetting: false,
      typeManagement: false
    }
  },
  created: function () {
    this.getTableData()
    this.getTypes()
  },
  methods: {
    getTableData () {
      let params = {
        title: this.searchForm.title
      }
      if (this.typeFilter) {
        params.type = this.selectedTypes
      }
      this.listGetting = true
      this.listError = false
      getContainerTemplates(params).then(res => {
        this.data = res.data
        this.listGetting = false
      }).catch(res => {
        this.listGetting = false
        console.log(res.response)
        this.listError = true
      })
    },
    handleDelete (id) {
      deleteContainerTemplate(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
        console.error(res.response)
      })
    },
    selectTemplate (id) {
      // this.deployTemplateId = id
      this.$refs.Deploy.showModal(id)
      // this.$nextTick(function () {
      //   document.querySelector('#container-template-base-div').scrollIntoView(true)
      // })
    },
    getTypes () {
      this.typeGetting = true
      this.typeError = false
      getContainerTemplateTypes().then(res => {
        this.types = res.data
        this.typeGetting = false
      }).catch(res => {
        this.typeError = true
        this.typeGetting = false
        console.error(res.response)
      })
    },
    deleteType (type) {
      this.$Modal.confirm({
        title: '删除',
        content: `确定要模板「${type.name}」类型吗？`,
        onOk: () => {
          deleteContainerTemplateType(type.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            if (this.selectedTypes.indexOf(type.id) > -1) {
              this.selectedTypes.splice(this.selectedTypes.indexOf(type.id), 1)
            }
            this.getTypes()
            this.getTableData()
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
              console.error(res.response)
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    },
    typeTemplateChange () {
      this.getTypes()
      this.getTableData()
    },
    typeChange () {
      if (this.typeFilter) {
        this.getTableData()
      }
    }
  }
}
</script>

<style scoped lang="less">
  .container-template {
    margin-bottom: 8px;
    .container-template-top {
      position: absolute;
      top: 16px;
      right: 16px;
      span {
        color: #999
      }
    }
    .container-template-title {
      font-size: 28px;
      font-weight: bold;
      margin: 5px 0;
      span {
        cursor: pointer;
      }
      span:hover {
        color: #108ee9;
      }
    }
    .container-template-footer {
      margin-top: 12px;
      position: relative;
      .container-template-footer-operate-btn {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .container-template-summary {
      margin-right: 100px;
      .container-template-summary-content {
        .context {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          span {
            cursor: pointer;
          }
          span:hover {
            color: #108ee9;
          }
        }
      }
    }
    /*<!--.type-operate-icon-rename {-->*/
      /*<!--color: @warning-color;-->*/
    /*<!--}-->*/
    /*<!--.type-operate-icon-trash {-->*/
      /*<!--color: @error-color;-->*/
    /*<!--}-->*/
  }
</style>
